function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#B4B4B4",
  points: "0,142.926 13.99,125.195 13.058,116.484 1.233,103.421 29.238,62.362 28.62,56.763 40.438,53.657  47.599,42.146 38.875,29.082 48.518,12.591 44.175,8.867 53.495,0.466 55.055,2.647 65.316,4.822 67.491,10.414 89.574,11.986  116.016,35.923 126.28,35.923 129.399,26.587 141.848,20.387 149.304,22.859 153.029,21.924 175.124,37.486 191.302,40.583  193.467,47.44 194.712,56.142 200,56.142 200,62.362 194.712,64.542 194.098,67.659 188.188,70.141 180.102,63.921 175.746,64.542  167.655,89.428 163.294,90.987 150.873,85.693 145.573,95.65 133.755,91.609 131.583,93.156 127.833,108.711 135.309,127.367  138.104,148.214 150.873,160.031 160.184,174.027 149.304,194.877 139.664,198.605 130.949,198.605 109.491,196.434  105.129,199.534 100.78,197.971 105.76,190.842 102.958,183.05 89.574,184.609 83.665,182.425 82.425,185.541 72.785,187.095  71.229,184.609 66.879,186.169 60.958,177.774 59.404,155.375 55.055,156.922 46.968,152.874 41.059,162.216 36.712,164.698  20.533,160.666 17.419,155.375 16.167,145.104 11.504,142.926 8.081,146.032 6.524,142.926 "
});

var Svg11 = function Svg11(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "GTO",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg11, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/11.da27e25d.svg";
export { ForwardRef as ReactComponent };